<template>
  <v-select
    v-model="timeSelected"
    prepend-icon="access_time"
    :label="$t(label)"
    hide-details
    :disabled="disabled"
    menu-props="auto"
    :items="timeOptions"
    item-disabled="disable"
    item-text="value"
    @change="onTimeSelected"
    required
  >
  </v-select>
</template>
<script>
import moment from 'moment';

export default {
  name: 'ReservationTimePicker',
  props: {
    label: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    minDate: Date,
    inputDate: Date,
    inputTime: {
      type: String,
    },
    parkingTimezone: {
      type: String,
      default: null,
    },
  },
  watch: {
    inputTime: function (value) {
      this.timeSelected = value;
      this.editing = true;
      if (
        moment(this.minDate)
          .startOf('day')
          .isSame(moment(this.inputDate).startOf('day'))
      ) {
        this.setTimeOptionsToday();
      } else {
        this.setTimeOptions();
      }
    },
    inputDate: function (value) {
      let aux = moment(value);
      if (!this.editing && aux.isBefore(moment(this.minDate))) {
        this.inuputDate = this.minDate;
        this.timeSelected = '';
        this.getNearestTime();
      }
    },
    minDate: function (value) {
      if (
        !this.editing &&
        moment(this.inputDate).isBefore(moment(this.minDate))
      ) {
        this.timeSelected = '';
      }
      if (
        moment(this.minDate)
          .startOf('day')
          .isSame(moment(this.inputDate).startOf('day'))
      ) {
        this.setTimeOptionsToday();
      } else {
        this.setTimeOptions();
      }
    },
    disabled: function (value) {
      if (moment().startOf('day').isSame(this.inputDate)) {
        this.setTimeOptionsToday();
      } else {
        this.setTimeOptions();
      }
    },
  },
  data() {
    return {
      timeOptions: [],
      timeSelected: '',
      editing: false,
    };
  },
  created() {
    this.setTimeOptions();
  },
  mounted() {
    this.timeOptions = [];
  },
  methods: {
    setTimeOptions() {
      let times = [];
      if (this.disabled) {
        times.push(this.inputTime);
        this.timeOptions = times;
      } else {
        // const quarterHours = ['00', '15', '30', '45'];
        const fiveMinutes = [
          '00',
          '05',
          '10',
          '15',
          '20',
          '25',
          '30',
          '35',
          '40',
          '45',
          '50',
          '55',
        ];
        for (let i = 0; i < 24; i++) {
          for (let j = 0; j < fiveMinutes.length; j++) {
            // Using slice() with negative index => You get always (the last) two digit numbers.
            times.push(('0' + i).slice(-2) + ':' + fiveMinutes[j]);
          }
        }
        this.timeOptions = times;
        this.getNearestTime();
      }
    },
    setTimeOptionsToday() {
      let times = [];
      if (this.disabled) {
        times.push(this.inputTime);
        this.timeOptions = times;
      } else {
        // const quarterHours = ['00', '15', '30', '45'];
        const fiveMinutes = [
          '00',
          '05',
          '10',
          '15',
          '20',
          '25',
          '30',
          '35',
          '40',
          '45',
          '50',
          '55',
        ];
        const now = this.getNowWithTimeZone();
        let nowMinutes = now.minutes();
        let nowHour = now.hours();
        for (let i = 0; i < 24; i++) {
          for (let j = 0; j < fiveMinutes.length; j++) {
            // Using slice() with negative index => You get always (the last) two digit numbers.
            if (
              i > nowHour ||
              (fiveMinutes[j] >= nowMinutes && i === nowHour)
            ) {
              times.push({
                value: ('0' + i).slice(-2) + ':' + fiveMinutes[j],
                disable: false,
              });
            } else {
              times.push({
                value: ('0' + i).slice(-2) + ':' + fiveMinutes[j],
                disable: true,
              });
            }
          }
        }
        this.timeOptions = times;
        this.getNearestTime();
      }
    },
    getNowWithTimeZone() {
      if (this.parkingTimezone === null) {
        return moment(this.minDate);
      }

      return moment(this.minDate).tz(this.parkingTimezone);
    },
    getExternalNearestTime(arg) {
      if (this.timeSelected) return this.timeSelected;
      let now = arg || moment(this.minDate);
      let minutes = now.minutes();
      let hours = now.hours();
      if (minutes === 0) {
        minutes = 0;
      } else if (minutes <= 5) {
        minutes = 5;
      } else if (minutes <= 10) {
        minutes = 10;
      } else if (minutes <= 15) {
        minutes = 15;
      } else if (minutes <= 20) {
        minutes = 20;
      } else if (minutes <= 25) {
        minutes = 25;
      } else if (minutes <= 30) {
        minutes = 30;
      } else if (minutes <= 35) {
        minutes = 35;
      } else if (minutes <= 40) {
        minutes = 40;
      } else if (minutes <= 45) {
        minutes = 45;
      } else if (minutes <= 50) {
        minutes = 50;
      } else if (minutes <= 55) {
        minutes = 55;
      } else {
        minutes = 0;
        if (hours === 23) {
          hours = 0;
          this.form.day = moment().add(1, 'day').format('YYYY-MM-DD');
        } else {
          hours++;
        }
      }
      return `${hours.toString().padStart(2, '0')}:${minutes
        .toString()
        .padStart(2, '0')}`;
    },
    onTimeSelected() {
      this.editing = false;
      this.$emit('on-time-selected', { timeSelected: this.timeSelected });
    },
    getNearestTime(value) {
      if (this.timeSelected !== '') {
        if (this.disabled) {
          return;
        }
      }
      this.timeSelected = this.getExternalNearestTime();
      this.onTimeSelected();
    },
  },
};
</script>
